export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-3xl mx-auto text-center">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100/60 text-secondary-700 text-xs font-medium mb-4">
              联络我们
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading mb-4">
              联系我们
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto mb-8">
              有任何问题、建议或合作意向？欢迎通过以下方式联系我们。我们重视每一位用户的反馈。
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
              <div className="p-5 md:p-6 bg-background-50 rounded-xl border border-background-200/40 hover:border-primary-500/20 transition-all duration-200 cursor-pointer">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-400 mx-auto mb-3">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 mb-1">商务合作</h3>
                <p className="text-xs text-foreground-500">bd@hongtao.tv</p>
              </div>

              <div className="p-5 md:p-6 bg-background-50 rounded-xl border border-background-200/40 hover:border-primary-500/20 transition-all duration-200 cursor-pointer">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500/10 text-accent-500 mx-auto mb-3">
                  <i className="ri-customer-service-2-line text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 mb-1">用户反馈</h3>
                <p className="text-xs text-foreground-500">feedback@hongtao.tv</p>
              </div>

              <div className="p-5 md:p-6 bg-background-50 rounded-xl border border-background-200/40 hover:border-primary-500/20 transition-all duration-200 cursor-pointer">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-500/10 text-secondary-500 mx-auto mb-3">
                  <i className="ri-file-add-line text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 mb-1">内容投稿</h3>
                <p className="text-xs text-foreground-500">submit@hongtao.tv</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}